import React, { useState, Fragment } from "react";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";
import _ from "../../../../i18n";
import { CustumedMatrix } from "tamtam-components";
import { RadioButton } from "primereact/radiobutton";
import { Tooltip } from "antd";

import {
  saveVolumetryCoefficients,
  getVolumetryCoefficients,
  saveEncodingDocTypes,
  getEncodingDocTypes,
} from "../../../../api";

import { parsePreference } from "../../../../utils";

import {
  IconClose,
  IconPencil,
  CheckIcon,
  SettingsIcon,
  AlertCircleIcon,
  CheckCircleIcon,
} from "../../../common/Icons";
import "./EncodingProgressionContent.local.scss";
import { CloseCircleOutlined } from "@ant-design/icons";
const VolumetryConfigContent = ({
  onClose,
  token,
  collaborator,
  organization,
  category,
}) => {
  const { user } = useSelector((state) => state.auth);
  const preferences =
    user && organization && user.userOrganizations.length > 0
      ? user.userOrganizations.find((item) => item.id === organization)
          .authorisation.preferences
      : {};
  //States
  const [formFocus, setFormFocus] = useState(false);
  const [editedSoftware, setEditedSoftware] = useState(null);
  const [seletedGrade, setSeletedGrade] = useState(null);
  const [editedDocType, setEditedDocType] = useState(null);
  const [updateMode, setUpdateMode] = useState(null);
  const [coefficients, setCoefficients] = useState([]);
  const [filtredCoefficients, setFiltredCoefficients] = useState([]);
  const [docTypes, setDocTypes] = useState([]);

  const renderColumns = (width) => {
    return [
      {
        id: "purchases",
        label: _("purchases"),
        isEditable: true,
        widthPercentage: width,
      },
      {
        id: "sales",
        label: _("sales"),
        isEditable: true,
        widthPercentage: width,
      },
      {
        id: "financial_transactions_coda",
        label: _("coda"),
        isEditable: true,
        widthPercentage: width - 1,
      },
      {
        id: "financial_transactions_noncoda",
        label: _("noncoda"),
        isEditable: true,
        widthPercentage: width - 1,
      },
      {
        id: "caisse",
        label: _("caisse"),
        isEditable: true,
        widthPercentage: width,
      },
      {
        id: "remunerationGerant",
        label: _("remuneration(G)"),
        isEditable: true,
        widthPercentage: width + 1,
      },
      {
        id: "remuneration",
        label: _("remuneration"),
        isEditable: true,
        widthPercentage: width + 1,
      },
    ];
  };

  let volumetryCoefficientsQuery = useQuery(
    ["collaboratorsQuery", organization],
    async () => {
      if (token) {
        try {
          const response = await getVolumetryCoefficients(
            organization,
            category.id,
            token
          );
          const coeffResponse = response.data.data;
          let filtredResponse = coeffResponse.filter(
            (item) => item.grade === collaborator.grade
          );
          setCoefficients(coeffResponse);
          setFiltredCoefficients(filtredResponse);
        } catch (e) {
          setCoefficients([]);
          return null;
        }
      }
    }
  );

  let docTypesQuery = useQuery(["docTypesQuery", organization], async () => {
    if (token) {
      try {
        const response = await getEncodingDocTypes(
          organization,
          category.id,
          token
        );
        const typeResponse = response.data.data;
        setDocTypes(typeResponse);
      } catch (e) {
        setDocTypes([]);
        return null;
      }
    }
  });

  const handleSaveSoftware = async (software) => {
    if (
      software.label === "" ||
      (software.purchases === 0 &&
        software.sales === 0 &&
        software.financial_transactions_coda === 0 &&
        software.financial_transactions_noncoda === 0 &&
        software.caisse === 0 &&
        software.remuneration === 0)
    ) {
      return;
    }
    try {
      const response = await saveVolumetryCoefficients({
        token,
        grade: collaborator.grade,
        organization,
        category: category.id,
        software,
      });
      let coefficientResponse = response.data.data;
      let newCoefficients = [];
      newCoefficients = [...coefficients].map((coefficient) => {
        if (coefficient.id === software.id) {
          return {
            ...coefficientResponse,
            ...JSON.parse(coefficientResponse.coefficient),
          };
        } else {
          return coefficient;
        }
      });
      let filtredResponse = newCoefficients.filter(
        (item) => item.grade === seletedGrade
      );
      setEditedSoftware(null);
      setFormFocus(false);
      setCoefficients(newCoefficients);
      setFiltredCoefficients(filtredResponse);
      // toast.success(_("saveSuccess"));
    } catch (e) {
      // toast.error(_("savingError"), { autoClose: true });
      return null;
    }
  };

  const handleSaveDocType = async (docType) => {
    try {
      const response = await saveEncodingDocTypes({
        token,
        organization,
        docType,
      });
      let docTypeResponse = response.data.data;
      let newDocTypes = [];
      newDocTypes = [...docTypes].map((element) => {
        if (element.id === docType.id) {
          return {
            ...docTypeResponse,
          };
        } else {
          return element;
        }
      });
      setEditedDocType(null);
      setDocTypes(newDocTypes);
      // toast.success(_("saveSuccess"));
    } catch (e) {
      // toast.error(_("savingError"), { autoClose: true });
      return null;
    }
  };

  const handleCoefficientsColumns = (column, line) => {
    if (column.id === "actions") {
      return editedSoftware && editedSoftware.id === line.id ? (
        <div className={`actions ${formFocus && "focus"}`}>
          <div
            className={`action ${
              editedSoftware.label !== "" &&
              (editedSoftware.purchases > 0 ||
                editedSoftware.sales > 0 ||
                editedSoftware.financial_transactions_coda > 0 ||
                editedSoftware.financial_transactions_noncoda > 0 ||
                editedSoftware.caisse > 0 ||
                editedSoftware.remuneration > 0)
                ? "active"
                : "disabled"
            }`}
            onClick={() => handleSaveSoftware(editedSoftware)}>
            <CheckIcon size={12} />
          </div>
          <div className="action" onClick={() => setEditedSoftware(null)}>
            <IconClose size={8} />
          </div>
        </div>
      ) : (
        <div className="actions">
          <div className="action" onClick={() => setEditedSoftware(line)}>
            <IconPencil size={12} />
          </div>
        </div>
      );
    } else {
      return editedSoftware && editedSoftware.id === line.id ? (
        <div className={editedSoftware && "focus"}>
          <input
            value={editedSoftware[column.id]}
            onChange={(event) =>
              setEditedSoftware({
                ...editedSoftware,
                [column.id]: event.target.value,
              })
            }
          />
        </div>
      ) : (
        <div className="matrix_title">{line[column.id]}</div>
      );
    }
  };

  const handleCoefficientsTitle = (title) => {
    return <div className="matrix_title">{_(title.label)}</div>;
  };

  const handleDocColumns = (column, line) => {
    if (column.id === "actions") {
      return editedDocType && editedDocType.id === line.id ? (
        <div className={`actions ${formFocus && "focus"}`}>
          <div
            className={`action ${
              line.doc !== editedDocType.doc ? "active" : "disabled"
            }`}
            onClick={() => handleSaveDocType(editedDocType)}>
            <CheckIcon size={12} />
          </div>
          <div className="action" onClick={() => setEditedDocType(null)}>
            <IconClose size={8} />
          </div>
        </div>
      ) : (
        <div className="actions">
          <div className="action" onClick={() => setEditedDocType(line)}>
            <IconPencil size={12} />
          </div>
        </div>
      );
    } else {
      return editedDocType && editedDocType.id === line.id ? (
        <div className={editedDocType && "focus"}>
          <div className="flex align-items-center">
            <RadioButton
              name="doc"
              value={column.id}
              onChange={() =>
                setEditedDocType({ ...editedDocType, doc: column.id })
              }
              checked={column.id === editedDocType.doc}
            />
          </div>
        </div>
      ) : (
        <div className="matrix_title">
          {line.doc === column.id ? (
            <CheckCircleIcon size="20" fill="#18a0fb" />
          ) : (
            ""
          )}
        </div>
      );
    }
  };

  const handleDocTitle = (title) => {
    return <div className="matrix_title">{title.label}</div>;
  };

  const renderCoefficienEditMatrix = () => {
    return (
      <Fragment>
        <div className="matrix_frame">
          <div style={{ display: "flex" }}>
            <div className="header_tabs">
              {["ADMIN", "SENIOR", "MEDIOR", "JUNIOR"].map((grade, i) => {
                return (
                  <div
                    key={i}
                    className={`tab_badge ${
                      seletedGrade === grade ? "tab_badge_active" : ""
                    }`}
                    onClick={() => {
                      setSeletedGrade(grade);
                      setEditedSoftware(null);
                      let filtredResponse = coefficients.filter(
                        (item) => item.grade === grade
                      );
                      setFiltredCoefficients(filtredResponse);
                    }}>
                    {_(grade)}
                  </div>
                );
              })}
            </div>
            <div
              className="action"
              onClick={() => {
                setUpdateMode(false);
                let filtredResponse = coefficients.filter(
                  (item) => item.grade === collaborator.grade
                );
                setFiltredCoefficients(filtredResponse);
              }}>
              <CloseCircleOutlined />
            </div>
          </div>
          <CustumedMatrix
            columns={[
              ...renderColumns(10),
              {
                id: "actions",
                label: "",
                isEditable: true,
                widthPercentage: 8,
              },
            ]}
            items={filtredCoefficients}
            handleCellule={handleCoefficientsColumns}
            handleTitle={handleCoefficientsTitle}
            headerTagBG={"#F8F9FA"}
          />
        </div>
      </Fragment>
    );
  };

  const renderCoefficientMatrix = () => {
    return (
      <Fragment>
        {volumetryCoefficientsQuery.isFetching ? (
          <div className="ripple_loading">
            <img src={"/img/Ripple-1s-150px.svg"} alt="" />
          </div>
        ) : coefficients.length === 0 ? (
          <div className="no_data">
            <div className="title">{_("noDataFound")}</div>
            <div className="subTitle">{_("noCollaboratorProductionFound")}</div>
          </div>
        ) : (
          <Fragment>
            <div className="matrix_frame">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex" }}>
                  {_("coefficientsConfig")}{" "}
                  <Tooltip
                    key="tool-1"
                    placement="top"
                    title={`${_(
                      "Ces coefficients dependent du niveau de seniorité :"
                    )} ${collaborator.grade}`}
                    mouseLeaveDelay={0}>
                    <div
                      style={{
                        margin: "0px 4px",
                      }}>
                      <AlertCircleIcon />
                    </div>
                  </Tooltip>{" "}
                  :
                </div>
                {parsePreference(preferences.settings)
                  .allowCoefficientsConfig && (
                  <div
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setUpdateMode(true);
                      setSeletedGrade("ADMIN");
                      let filtredResponse = coefficients.filter(
                        (item) => item.grade === "ADMIN"
                      );
                      setFiltredCoefficients(filtredResponse);
                    }}>
                    <Tooltip
                      key="tool-1"
                      placement="top"
                      title={_("EditCoefficients")}
                      mouseLeaveDelay={0}>
                      <div
                        style={{
                          margin: "0px 4px",
                        }}>
                        <SettingsIcon size={18} fill="#18A0FB" />
                      </div>
                    </Tooltip>
                  </div>
                )}
              </div>
              <CustumedMatrix
                columns={renderColumns(10)}
                items={filtredCoefficients}
                handleCellule={handleCoefficientsColumns}
                handleTitle={handleCoefficientsTitle}
                headerTagBG={"#F8F9FA"}
              />
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  };

  const renderDocTypeMatrix = () => {
    return (
      <Fragment>
        {docTypesQuery.isFetching ? (
          <div className="ripple_loading">
            <img src={"/img/Ripple-1s-150px.svg"} alt="" />
          </div>
        ) : docTypes.length === 0 ? (
          <div className="no_data">
            <div className="title">{_("noDataFound")}</div>
            <div className="subTitle">{_("noAttribution")}</div>
          </div>
        ) : (
          <Fragment>
            <div className="matrix_frame second_matrix">
              <div>{_("docTypesConfig")} :</div>
              <CustumedMatrix
                columns={
                  updateMode
                    ? [
                        ...renderColumns(10),
                        {
                          id: "actions",
                          label: "",
                          isEditable: true,
                          widthPercentage: 8,
                        },
                      ]
                    : renderColumns(10)
                }
                items={docTypes}
                handleCellule={handleDocColumns}
                handleTitle={handleDocTitle}
                headerTagBG={"#F8F9FA"}
              />
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  };

  return (
    <div style={{ width: 900 }}>
      <div className="sidebar_header" style={{ marginTop: 45 }}>
        <div className="sidebar_header_infos">
          <h3>{_("EncodingSetting")}</h3>
        </div>
        <div className="sidebar_header_action" onClick={onClose}>
          <IconClose size={12} />
        </div>
      </div>
      <div className="sidebar_body vertical_content">
        {updateMode ? renderCoefficienEditMatrix() : renderCoefficientMatrix()}
        {renderDocTypeMatrix()}
      </div>
    </div>
  );
};

export default VolumetryConfigContent;
